import React from 'react';
import { Button, Form, FormGroup, FormControl, Col, Row, ButtonGroup, ToggleButton } from 'react-bootstrap';
import axios from 'axios';

import constants from '../../../util/constants';
const { API_BASE_URL } = constants;

class TwoFactorSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleRange: [
                { name: 'Active', value: 1 },
                { name: 'Inactive', value: 0 }
            ],
            useTwoFactor: 0,
            sessionExpirationDays: 0,
        }

        this.axiosCancelSource = axios.CancelToken.source();
        this.apiOptions = { headers: { 'Authorization': 'Bearer ' + this.props.apiToken }, cancelToken: this.axiosCancelSource.token };

        this.toggleState = this.toggleState.bind(this)
        this.getTwoFactorSettings = this.getTwoFactorSettings.bind(this)
        this.updateTwoFactorSettings = this.updateTwoFactorSettings.bind(this)
    }

    componentDidMount() {
        this.getTwoFactorSettings()
    }

    getTwoFactorSettings() {
        const self = this;

        axios.get(API_BASE_URL + 'Portal/GetTwoFactorSettings', self.apiOptions)
            .then(res => {
                if (res?.data) {
                    const { SessionExpirationDays, UseTwoFactor } = res.data
  
                    self.setState({
                        sessionExpirationDays: SessionExpirationDays,
                        useTwoFactor: UseTwoFactor
                    })
                }
            })
            .catch(err => {
                console.error(err)
            });
    }

    updateTwoFactorSettings() {
        const self = this;

        let twoFactorSettings = {
            SessionExpirationDays: self.state.sessionExpirationDays > 30 ? 30 : self.state.sessionExpirationDays,
            UseTwoFactor: self.state.useTwoFactor == 1
        };

        axios.post(API_BASE_URL + 'Portal/UpdateTwoFactorSettings', twoFactorSettings, self.apiOptions)
            .then(response => {
                this.setState({
                    success: true,
                    successMessage: 'Two factor settings successfully updated!'
                }, () => setTimeout(() => { this.setState({ success: false }) }, 5000));
            })
            .catch(err => {
                this.setState({
                    error: true,
                    errorMessage: 'Could not update two factor settings.'
                }, () => setTimeout(() => { this.setState({ error: false }) }, 5000))
            })
    }

    toggleState(state, item) {
        this.setState({
            [state]: item
        })
    }

    render() {
        const { toggleRange, useTwoFactor, sessionExpirationDays } = this.state
        return (
            <div className="create-user">
                <section>
                    <div className="center-block text-center user-heading"> Two factor authentication Settings </div>
                    <Form horizontal >
                        <section>
                            <FormGroup controlId="formHorizontal2FA" bsSize="small">
                                <Row>
                                    <Col sm={2}>
                                        <label>Toggle 2FA usage</label>
                                        <ButtonGroup className="np-radio-wrapper" toggle="toggle">
                                            {toggleRange.map((radio, idx) => (
                                                <ToggleButton
                                                    key={idx}
                                                    type="radio"
                                                    variant="secondary"
                                                    name="radio"
                                                    value={radio.value}
                                                    checked={useTwoFactor === radio.value}
                                                    className={useTwoFactor == radio.value ? 'active' : ''}
                                                    onChange={(e) => this.toggleState("useTwoFactor", e.target.value)}
                                                >
                                                    {radio.name}
                                                </ToggleButton>
                                            ))}
                                        </ButtonGroup>
                                    </Col>
                                    <Col sm={10}>
                                        <label>Default length for 2FA sessions</label>
                                        <FormControl style={{width: '100px'}} type="number" max="30" value={sessionExpirationDays} onChange={(e) => this.toggleState("sessionExpirationDays", e.target.value)}></FormControl>
                                    </Col>
                                </Row>
                                <Row className="margin-top-10">
                                    <Col sm={12}>
                                        {this.state.success &&
                                            <div>
                                                <label>{this.state.successMessage}</label>
                                            </div>
                                        }
                                        {this.state.showError &&
                                            <div>
                                                <label className="danger">{this.state.errorMessage}</label>
                                            </div>
                                        }
                                        <Button bsStyle="primary" className="margin-left-10 pull-right" onClick={this.updateTwoFactorSettings}>Save two factor settings</Button>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </section>
                    </Form>
                </section>
            </div>
        );
    }
}
export default TwoFactorSettings;